import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async () => {
  return await axiosIns.get(obtenerUrl('sedes'));
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl('sedes'), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`sedes/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`sedes/${id}`));
};

export default {
  get,
  store,
  update,
  destroy,
};
